export enum RecordExportTransformation {
    DIRECT = 'direct',
    TRANSFORMED = 'transformed',
    CROPPED = 'cropped',
    EXPORT = 'export'
}
